import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d7dced9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center mt-4" }

import esamiAggiuntiveEdit from '@/views/Esami/esamiAggiuntiveEdit.vue'
import esamiConfidenzialita from '@/views/Esami/esamiConfidenzialita.vue'
import esamiSposta from '@/views/Esami/esamiSposta.vue'
import esamiFiles from '@/views/Esami/esamiFiles.vue'
import esamiDownload from '@/views/Esami/esamiDownload.vue'
import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { CollapsableModel } from "@/../../EshJSLib/models/CollapsableModel";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";

import schemaProgrammati from "@/../../EshJSLib/models/form/esamiProgrammati.json";
import schemaRichiesti from "@/../../EshJSLib/models/form/esamiRichiesti.json";
import schemaCompletati from "@/../../EshJSLib/models/form/esamiCompletati.json";

import esami from "@/../../EshJSLib/models/form/esami.json";
import { ref, onMounted, reactive, computed } from "vue";
import { getStatiIndagini } from "@../../../../EshJSLib/services/EshLOV";
import { Esami } from "@/../../EshJSLib/models/patient";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { saveFile } from "../../../../EshJSLib/services/fileServices";
import loadingComponent from '@/components/loadingComponent.vue'
import { updateEsami, saveEsami, filterEsami } from '../../../../EshJSLib/services/esamiServices'
import SearchBox from '@/components/SearchBox.vue'
import { EsamiCollection } from '@/../../EshJSLib/models/patient'
import SearchResultTable from '@/components/SearchResultTable.vue'
import PrintButton from '@/components/PrintButton.vue'
import { previewEsami } from "../../../../EshJSLib/services/donwloadService";
import { useRouter } from "vue-router";
import { Modal } from "flowbite-vue";
import { hasPermission } from '../../../../EshJSLib/services/securityServices'


export default /*#__PURE__*/_defineComponent({
  __name: 'EsamiPage',
  setup(__props) {

const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const modalAddEdit = ref<InstanceType<typeof esamiAggiuntiveEdit> | null>(null);
const modalConfidenzialita = ref<InstanceType<typeof esamiConfidenzialita> | null>(null);
const modalSposta = ref<InstanceType<typeof esamiSposta> | null>(null);
const modalFile = ref<InstanceType<typeof esamiFiles> | null>(null);
const modalDownload = ref<InstanceType<typeof esamiDownload> | null>(null);

const store = patientStore();
const { patient } = storeToRefs(store);

let filterArray = ["Ricerca", "All Esami", "Esami Completati", "Esami Programmati", "Esami Richiesta"];

let filenew = reactive({
  id_paziente: patient.value.id_paziente,
  id_autore: patient.value.id_paziente,
  id_a_log: 1,
  id_file: null,
  file_commento: '',
  file_nome: '',
  file_type: '',
  file: null,
  type: '',
  tags: '',
  file_size: 0,
  created_at: null,
  id_livello_confidenzialita: 1,
  id_indagine: null
});

const showLoading = ref(false);

const router = useRouter();
const isShownModalSub = reactive({
  alert: false,
  movePage: false,
  confirm: false,
  alertMove: false,
});

function movePage() {
  router.push({ path: 'Paypal' })
}

async function saveAndRefreshEsami(userInput: boolean, row: Esami) {
  if (row.id_indagine == 0) {
    patient.value.esami = patient.value.esami.concat(row);
  }

  if (userInput) {
    showLoading.value = true;

    store.savePaziente('esami', row.id_indagine).then((x) => {
      store.fetchEsami().then(() => {
        showLoading.value = false;
      })
    }).catch((error) => {
      showLoading.value = false;
      alertModal.value.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false)
    })
  } else {
    store.fetchFarmaci();
  }
}

async function action(type: string, row: Esami, index: number, table: string) {
  let userInput = false;

  switch (type) {
    case "add":
      if (await hasPermission('aggiungiesame')) {
        row = {} as Esami
        row.id_indagine = 0
        row.id_paziente = patient.value.id_paziente
        row.author_id = patient.value.id_paziente
        row.id_livello_confidenzialita = 6
        row.indagine_stato = table
        //row.status = 'add'
        userInput = await modalAddEdit.value?.openModal("Aggiungi nuovo esame", row);
        saveAndRefreshEsami(userInput, row)
      } else {
        isShownModalSub.alert = true;
      }
    break;

    case "pen":
      //row.status = 'update'
      if (await hasPermission('modificaesame')) {
        userInput = await modalAddEdit.value?.openModal("Modifica Esame", row);
        saveAndRefreshEsami(userInput, row)
      } else {
        isShownModalSub.alert = true;
      }
    break;

    case "lock":
      //row.status = 'update'
      userInput = await modalConfidenzialita.value?.openModal("Modifica Confidenzialita'", row);
      saveAndRefreshEsami(userInput, row)
    break;

    case "up-down":
      //row.status = 'update'
      if (await hasPermission('spostaEsame')) {
        userInput = await modalSposta.value?.openModal("Sposta", row);
        saveAndRefreshEsami(userInput, row);
      } else {
        isShownModalSub.alert = true;
      }
    break;

    case 'trash':
      alertModal.value.openModal("Sei sicuro di cancellare il record?", true).then((userInput) => {
        //row.status = 'delete'
        row.indagine_stato = '3';
        row.deleted_at = new Date();
        saveAndRefreshEsami(userInput, row)
      })
    break;

    case 'paperclip':
      filenew = {
        id_paziente: patient.value.id_paziente,
        id_autore: patient.value.id_paziente,
        id_indagine: row.id_indagine,
        id_a_log: null,
        id_file: null,
        file_commento: '',
        file_nome: '',
        file_type: '',
        file: null,
        type: '',
        tags: '',
        file_size: 0,
        created_at: null,
        id_livello_confidenzialita: 1,
      };

      userInput = await modalFile.value?.openModal("Agguingi file: ", filenew);
      saveFileFE(filenew);
    break;

    case 'download':
      userInput = await modalDownload.value?.openModal("Download FIle: ", row);
    break;
  }
}

function saveFileFE(filenew: any) {
  if (!filenew.type || !filenew.id_livello_confidenzialita) {
    return;
  }
  console.log(filenew);

  try {
    const payload = filenew;
    saveFile(payload).then((data) => {
      store.fetchFiles();
      store.fetchEsami();
      alert("File caricato con successo!");
    });
  } catch (e) {
    store.fetchFiles();
    store.fetchEsami();
    console.log(e);
    alert("Si è verificato un problema. Si prega di riprovare più tardi, se il problema persiste scrivici a info@micurobene.it");
  }
}

onMounted(async () => {
  store.fetchEsami();
  store.fetchDiagnosi();
  store.fetchCentri();
});

let page = ref('Ricerca:');

//   const updatePage = (selectedPage) => {
//   page.value = selectedPage;
// };

let esamiSrc = ref(false);
let filteredEsami = {} as EsamiCollection;
let esamiSearch = "";
const filteredEsamiReact = reactive(filteredEsami);

let searchDone = ref(false);
let resultLabels = ['Careprovider', 'Indagine Stato', 'Indagine Tipologia', 'Indagine Motivo', 'Centro Indagine'];
let resultColumns = ['careprovider', 'indagine_stato', 'indagine_tipologia', 'indagine_motivo', 'id_centro_indagine'];

function findEsami() {
  esamiSrc.value = true;
  filteredEsami = {};

  if (esamiSearch.length < 3) {
    return;
  }

  var res = filterEsami(esamiSearch, patient.value.id_paziente);
  showLoading.value = true;
  res
    .then((value) => {
      filteredEsamiReact.Esami = value;
      esamiSrc.value = false;
      showLoading.value = false;
      searchDone.value = true;
    })
    .catch((error) => {
      filteredEsamiReact.Esami = [];
      esamiSrc.value = false;
      showLoading.value = false;
      searchDone.value = true;

    });
}

function printEsami() {
  previewEsami(patient.value.id_paziente);
}

return (_ctx: any,_cache: any) => {
  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(AlertModal, {
          ref_key: "alertModal",
          ref: alertModal
        }, null, 512),
        _createVNode(esamiAggiuntiveEdit, {
          ref_key: "modalAddEdit",
          ref: modalAddEdit
        }, null, 512),
        _createVNode(esamiConfidenzialita, {
          ref_key: "modalConfidenzialita",
          ref: modalConfidenzialita
        }, null, 512),
        _createVNode(esamiSposta, {
          ref_key: "modalSposta",
          ref: modalSposta
        }, null, 512),
        _createVNode(esamiFiles, {
          ref_key: "modalFile",
          ref: modalFile
        }, null, 512),
        _createVNode(esamiDownload, {
          ref_key: "modalDownload",
          ref: modalDownload
        }, null, 512),
        (showLoading.value)
          ? (_openBlock(), _createBlock(loadingComponent, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(SearchBox, {
          modelValue: _unref(esamiSearch),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(esamiSearch) ? (esamiSearch).value = $event : esamiSearch = $event)),
          "search-what": 'Tipo..',
          page: _unref(page),
          items: _unref(filterArray),
          onFilter: findEsami
        }, null, 8, ["modelValue", "search-what", "page", "items"]),
        (_unref(searchDone))
          ? (_openBlock(), _createBlock(SearchResultTable, {
              key: 1,
              labels: _unref(resultLabels),
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_isRef(searchDone) //@ts-ignore
 ? searchDone.value = false : searchDone = false)),
              "filtered-data": filteredEsamiReact.Esami,
              "displayed-columns": _unref(resultColumns),
              "search-word": _unref(esamiSearch)
            }, null, 8, ["labels", "filtered-data", "displayed-columns", "search-word"]))
          : _createCommentVNode("", true),
        _createVNode(CollapsibleItem, {
          id: "richiestiCollaps",
          data: _unref(schemaRichiesti),
          onRowActions: _cache[2] || (_cache[2] = (n, r, i) => action(n, r, i, 'esami_richiesti')),
          onCreateForm: _cache[3] || (_cache[3] = ($event: any) => (action('add', null, 0, '0')))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          id: "programmatiCollaps",
          data: _unref(schemaProgrammati),
          onRowActions: _cache[4] || (_cache[4] = (n, r, i) => action(n, r, i, 'esami_programmati')),
          onCreateForm: _cache[5] || (_cache[5] = ($event: any) => (action('add', null, 1, '1')))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          id: "completatiCollaps",
          data: _unref(schemaCompletati),
          onRowActions: _cache[6] || (_cache[6] = (n, r, i) => action(n, r, i, 'esami_completati')),
          onCreateForm: _cache[7] || (_cache[7] = ($event: any) => (action('add', null, 2, '2')))
        }, null, 8, ["data"]),
        _createVNode(PrintButton, { onPrint: printEsami }),
        (isShownModalSub.alert)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 2,
              onClose: _cache[10] || (_cache[10] = ($event: any) => (isShownModalSub.alert = false))
            }, {
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (isShownModalSub.alert = false)),
                    type: "button",
                    class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                  }, _toDisplayString(_ctx.$t("Annulla")), 1),
                  _createElementVNode("button", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (movePage())),
                    type: "button",
                    class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                  }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})